export default __webpack_public_path__ + "static/media/location.7b77efcd.png";